import type { StyledComponentProps } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Grid from '@material-ui/core/Grid';
import Product from 'classes/Product';
import Alert from 'components/Alert';
import { EProductStatus } from 'helpers/enums';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import scrollToComponent from 'react-scroll-to-component';
import { toast } from 'react-toastify';
import Delivery from 'scenes/Producer/Product/components/InfoDeliveryMethods';
import DeliveryValidations from 'scenes/Producer/Product/components/InfoDeliveryMethods/validations';
import General from 'scenes/Producer/Product/NewProduct/components/Forms/General';
import GeneralValidations from 'scenes/Producer/Product/NewProduct/components/Forms/General/validations';
import Sales from 'scenes/Producer/Product/NewProduct/components/Forms/Sales';
import SalesSubscriptionValidations from 'scenes/Producer/Product/NewProduct/components/Forms/Sales/components/Subscription/validations';
import SalesValidations from 'scenes/Producer/Product/NewProduct/components/Forms/Sales/validations';
import { listMyProducts, loadProduct, newProduct } from 'store/Orbita/Product/actions';
import TopPage from 'v2/components/Shared/TopPage';
import chatBotService, { Activity } from 'v2/services/chatBot';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { run } from 'validations/ruleRunner';

import DraftButtons from '../../components/DraftButtons';
import Hints from '../../components/Hints';
import { PrivateLabelRights } from '../../components/PrivateLabelRights';
import styles from './styles';

import type IProduct from 'interfaces/IProduct';
import type IUser from 'interfaces/IUser';
import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

interface IProps extends DispatchProp<any>, RouteComponentProps<any>, StyledComponentProps {
  newProduct: IProduct;
  listProducts: Array<IProduct>;
  categories: any;
  currencies: any;
  isLoading: boolean;
  user: IUser;
  product: IProduct;
}

interface IStates {
  product: IProduct;
  productTitleExists: boolean;
  enabledValidation: boolean;
  categoryLabel: any;
}

class InfoProduct extends Component<IProps, IStates> {
  validation: any;
  errorsRef: any;
  fieldsRef: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      product: new Product({ undetermined_charges: true }),
      productTitleExists: false,
      enabledValidation: false,
      categoryLabel: null,
    };
    this.errorsRef = {};
    this.fieldsRef = {};
  }

  handleClickSubmitDraft = async () => {
    const confirm = await Alert.show({
      message: 'O seu produto não poderá ser vendido enquanto você não publicá-lo para venda. Deseja Continuar?',
      title: 'Atenção!',
      confirmation: true,
    });
    if (confirm) {
      this.handleSubmit(true);
    }
    return;
  };

  handleClickSubmit = async () => {
    const confirm = await Alert.show({
      message: 'O seu produto será enviado para moderação e você receberá o seu link para vendê-lo. Deseja Continuar?',
      title: 'Atenção!',
      confirmation: true,
    });
    if (confirm) {
      this.handleSubmit();
    }
    return;
  };

  setRefField = (name: any, ref: any) => {
    this.fieldsRef[name] = ref;
  };

  setRefError = (name: any, ref: any) => {
    this.errorsRef[name] = ref;
  };

  handleChange = (name: string, value: any) => {
    const currentProduct = this.state.product;
    currentProduct[name] = value;
    const product: IProduct = new Product(currentProduct);
    this.setState({ product });
  };

  handleCategory = (categories: any) => {
    let product: IProduct = new Product(this.state.product);
    product['categories'] = categories;
    this.setState({ product, categoryLabel: categories });
  };

  handleUploadEvents = (event: any) => {
    if (event === 'uploading') {
    } else if (event === 'error') {
    }
  };

  handleChangeDeliveries = (deliveries: any) => {
    let product: IProduct = new Product(this.state.product);
    product.setDeliveries(deliveries);
    this.setState({ product });
  };

  onUpload = (uploadId: number) => {
    let product: IProduct = new Product(this.state.product);
    product.private_label_rights = uploadId;
    this.setState({ product });
  };

  onRemoveUpload = () => {
    let product: IProduct = new Product(this.state.product);
    product.private_label_rights = 0;
    this.setState({ product });
  };

  validateTitleForSave = (productTitle: string) => {
    (async () => {
      try {
        await this.props.dispatch(listMyProducts({ exact_title: productTitle }, { current_page: 1, per_page: 1 }));
        let product = this.props.listProducts;
        if (product.length > 0) {
          this.setState({ productTitleExists: true });
        } else {
          this.setState({ productTitleExists: false });
        }
      } catch (error) {}
    })();
  };

  isFormValid: Function = (product: IProduct, scroll: boolean = true): boolean => {
    const GeneralErrors = run(product, GeneralValidations);
    const generalRequiredFields = GeneralErrors ? Object.keys(GeneralErrors).length : 0;
    let SingleErrors = [];
    let SubscriptionErrors = [];
    let salesRequiredFields = 0;

    if (product && product.charge_type === 'N') {
      SingleErrors = run(product, SalesValidations);
      salesRequiredFields += SingleErrors ? Object.keys(SingleErrors).length : 0;
    }

    if (product && product.charge_type === 'A') {
      SubscriptionErrors = run(product, SalesSubscriptionValidations);
      salesRequiredFields += SubscriptionErrors ? Object.keys(SubscriptionErrors).length : 0;
    }
    const DeliveryErrors = run(product, DeliveryValidations);
    const deliveryRequiredFields = DeliveryErrors ? Object.keys(DeliveryErrors).length : 0;

    this.scrollToInvalidFields(GeneralErrors, generalRequiredFields, salesRequiredFields, deliveryRequiredFields, scroll);

    return generalRequiredFields === 0 && salesRequiredFields === 0 && deliveryRequiredFields === 0;
  };

  scrollToInvalidFields = (
    generalErrors: any,
    generalRequiredFields: number,
    salesRequiredFields: number,
    deliveryRequiredFields: number,
    shouldScroll: boolean = true
  ) => {
    if (!shouldScroll) {
      return;
    }
    if (generalRequiredFields > 0) {
      const prop = Object.keys(generalErrors)[0];
      scrollToComponent(this.fieldsRef[prop]);
      return;
    }
    if (salesRequiredFields > 0) {
      scrollToComponent(this.fieldsRef['sales']);
      return;
    }
    if (deliveryRequiredFields) {
      scrollToComponent(this.fieldsRef['deliveries']);
      return;
    }
  };

  backWizard = () => {
    this.props.dispatch({ type: 'PREVIOUS_STEP_WIZARD_NP' });
  };

  handleSubmit = (isDraft: boolean = false) => {
    const product = this.state.product;
    if (isDraft) {
      product.active = EProductStatus.DRAFT;
    }
    this.props.dispatch({ type: 'RESET_LOAD_WIZARD_NP' });
    if (isDraft || this.isFormValid(product)) {
      (async () => {
        try {
          this.props.dispatch({ type: 'UPDATE_LOAD_WIZARD_NP', percent: 33 });
          await this.props.dispatch(newProduct(product.serviceFormat()));
          const prod = this.props.newProduct;
          this.props.dispatch({ type: 'UPDATE_LOAD_WIZARD_NP', percent: 66 });

          if (isDraft) {
            toast.success('Seu produto foi salvo como rascunho!');
            this.props.history.push('/producer/product/myproducts');
          }

          await this.props.dispatch(loadProduct(prod.id));
          let newProd = new Product(this.props.product);
          newProd.setDeliveries(product?.deliveries || []);
          await this.props.dispatch({ type: 'INSERT_PRODUCT_WIZARD_NP', product: newProd });
          await this.props.dispatch({ type: 'UPDATE_LOAD_WIZARD_NP', percent: 100 });
          this.props.dispatch({ type: 'RESET_LOAD_WIZARD_NP' });
          this.props.dispatch({ type: 'NEXT_STEP_WIZARD_NP' });
          if (!this.props.user.producer) {
            eduzzAccountsService.loadAccountDetails();
          }
        } catch (error) {
          toast.error(error);
          this.props.dispatch({ type: 'RESET_LOAD_WIZARD_NP' });
          return;
        }

        chatBotService.activity(Activity.productRegistered);
      })();
    } else {
      this.setState({ enabledValidation: true });
      toast.error('Por favor preencha todos os campos obrigatórios');
    }
  };

  render() {
    const { classes, categories, currencies } = this.props;
    const { product, productTitleExists, enabledValidation, categoryLabel } = this.state;

    return (
      <Grid id='new-infoproduct' container spacing={2}>
        <Grid item xs={12}>
          <Breadcrumbs aria-label='breadcrumb'>
            <Link to='/producer/product/myproducts'>Meus Produtos</Link>
            <a style={{ cursor: 'pointer' }} onClick={this.backWizard}>
              Tipo de produto
            </a>
            <p>Novo produto</p>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12}>
          <TopPage
            title='Novo Produto Digital'
            helpLink='https://ajuda.eduzz.com/hc/pt-br/articles/4403015162139-O-que-é-um-infoproduto-digital-e-como-cadastrar-'
          />
        </Grid>

        <Grid item md={9} xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <General
                setRefField={this.setRefField}
                setRefError={this.setRefError}
                product={product}
                handleChange={this.handleChange}
                handleCategory={this.handleCategory}
                categoryList={categories}
                categorySelected={categoryLabel}
                validateTitleForSave={this.validateTitleForSave}
                productTitleExists={productTitleExists}
                enabledValidation={enabledValidation}
              />
            </Grid>
            <Grid item xs={12}>
              <Sales
                ref={(ref: any) => this.setRefField('sales', ref)}
                product={product}
                handleChange={this.handleChange}
                currencyList={currencies}
                setRefField={this.setRefField}
                setRefError={this.setRefError}
                enabledValidation={enabledValidation}
              />
            </Grid>
            <Grid item xs={12}>
              <Delivery
                ref={(ref: any) => this.setRefField('deliveries', ref)}
                newProduct={true}
                fade={true}
                classes={classes}
                deliveries={product ? product.deliveries : []}
                onChange={this.handleChangeDeliveries}
                isInfo={true}
                offer={product}
              />
            </Grid>
            <Grid item xs={12}>
              <PrivateLabelRights onUpload={this.onUpload} onRemove={this.onRemoveUpload} />
            </Grid>
            <Grid item xs={12}>
              <DraftButtons
                disabled={{ tooltip: this.isFormValid(product, false), button: !this.isFormValid(product, false) }}
                disabledDraft={{ tooltip: !!product.title, button: !product.title }}
                onSubmit={() => this.handleClickSubmit()}
                onSubmitDraft={() => this.handleClickSubmitDraft()}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={3} xs={12}>
          <Hints type='digital' />
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    categories: state.orbita.Product.categories,
    newProduct: state.orbita.Product.new.product,
    currencies: state.orbita.Currency.list,
    listProducts: state.orbita.Product.listMine.data,
    isLoading: state.components.newProductWizard.loading.active,
    user: state.orbita.User.user,
    product: state.orbita.Product.product,
  };
}

export default withRouter(connect(mapStateToProps)(styles(InfoProduct)));
